import { IPublicOrdersWebSocketActions } from "../../definitions/middlewares/IPublicOrdersWebSocketActions";
import { IPrivateOrdersWebSocketActions } from "../../definitions/middlewares/IPrivateOrdersWebSocketActions";

export const WS_ALL_ORDERS_CONNECTION_START: 'WS_ALL_ORDERS_CONNECTION_START' = 'WS_ALL_ORDERS_CONNECTION_START';
export const WS_ALL_ORDERS_CONNECTION_SUCCESS: 'WS_ALL_ORDERS_CONNECTION_SUCCESS' = 'WS_ALL_ORDERS_CONNECTION_SUCCESS';
export const WS_ALL_ORDERS_CONNECTION_ERROR: 'WS_ALL_ORDERS_CONNECTION_ERROR' = 'WS_ALL_ORDERS_CONNECTION_ERROR';
export const WS_ALL_ORDERS_CONNECTION_CLOSED: 'WS_ALL_ORDERS_CONNECTION_CLOSED' = 'WS_ALL_ORDERS_CONNECTION_CLOSED';
export const WS_GET_ALL_ORDERS_MESSAGE: 'WS_GET_ALL_ORDERS_MESSAGE' = 'WS_GET_ALL_ORDERS_MESSAGE';

export const WS_USER_ORDERS_CONNECTION_START: 'WS_USER_ORDERS_CONNECTION_START' = 'WS_USER_ORDERS_CONNECTION_START';
export const WS_USER_ORDERS_CONNECTION_SUCCESS: 'WS_USER_ORDERS_CONNECTION_SUCCESS' = 'WS_USER_ORDERS_CONNECTION_SUCCESS';
export const WS_USER_ORDERS_CONNECTION_ERROR: 'WS_USER_ORDERS_CONNECTION_ERROR' = 'WS_USER_ORDERS_CONNECTION_ERROR';
export const WS_GET_USER_ORDERS_MESSAGE: 'WS_GET_USER_ORDERS_MESSAGE' = 'WS_GET_USER_ORDERS_MESSAGE';
export const WS_USER_ORDERS_CONNECTION_CLOSED: 'WS_USER_ORDERS_CONNECTION_CLOSED' = 'WS_USER_ORDERS_CONNECTION_CLOSED';

export const allOrdersWsActions: IPublicOrdersWebSocketActions = {
  wsInit: WS_ALL_ORDERS_CONNECTION_START,
  onOpen: WS_ALL_ORDERS_CONNECTION_SUCCESS,
  onClose: WS_ALL_ORDERS_CONNECTION_CLOSED,
  onError: WS_ALL_ORDERS_CONNECTION_ERROR,
  onMessage: WS_GET_ALL_ORDERS_MESSAGE
}

export const userOrdersWsActions: IPrivateOrdersWebSocketActions = {
  wsInit: WS_USER_ORDERS_CONNECTION_START,
  onOpen: WS_USER_ORDERS_CONNECTION_SUCCESS,
  onClose: WS_USER_ORDERS_CONNECTION_CLOSED,
  onError: WS_USER_ORDERS_CONNECTION_ERROR,
  onMessage: WS_GET_USER_ORDERS_MESSAGE
}